<template>
	<div>
		<!-- <div class="intro">
			<div>Please follow the instructions on the calendar below to book your classes. </div>
			<div>You can filter by day, time and age, and you can book single or multiple sessions at once after clicking "book now" of your chosen starting date.</div>
		</div> -->
		<div class="intro">
			<img :src="imgBaseUrl+type_image" alt="">
		</div>
		<!-- <div class="intro second_intro " >Click "Next week" on the calendar to view more classes</div> -->
		<div class="intro canClick " @click="getShopDetail">Click HERE to learn the timetables of other venues</div>
		<!-- <div class="intro canClick" >Please Note: The Mobile version of our website is still developing, please use your laptop/PC to view our webpages and book classes.</div> -->
		<div class="calendar_box">
			<div class="calendar_main">
				<div class="select_list flex">
					<div class="item flex align-center justify-between">
						<el-select v-model="course_age_id" clearable  placeholder="for any age" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in ageList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="timeStatus" clearable   placeholder="Any time" size="small"  @change="changeTime">
						   <el-option
						     v-for="item in timeOptions"
						     :key="item.value"
						     :label="item.label"
						     :value="item.value">
						   </el-option>
						</el-select>
						
					</div>
					<!-- <div class="item flex align-center justify-between">
						<el-select v-model="course_shop_id" placeholder="Any Venue" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in shopList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="course_type_id" placeholder="Any class" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in classifyList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div> -->
					<div class="item flex align-center ustify-between">
						<el-select v-model="selectWeek" clearable  placeholder="Any day" size="small"  @change="changeWeek">
						   <el-option
						     v-for="item in selectWeekList"
						     :key="item.id"
						     :label="item.label"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
				</div>
				<div class="calendar_header flex align-center justify-between">
					<div class="left flex align-center" @click="lastMonth">
						<img src="../../../assets/images/icon/left.png" alt="">
						<span>Last week</span>
					</div>
					<div class="date">{{showTime1}}-{{showTime2}}</div>
					<div class="right flex align-center" @click="nextMonth">
						<span>Next week </span>
						<img src="../../../assets/images/icon/right.png" alt="">
					</div>
				</div>
				<div class="weeklist">
					<ul class="weekName flex align-center justify-between">
						<li class="item" v-for="(item,index) in weekList" :key="index">
							<span>{{item}}</span>
							<span class="day">{{weekDayList[index]}}</span>
						</li>
					</ul>
					<div class="course_list flex justify-between">
						<div class="day_item" v-for="(item,index) in courseList" :key="index"  >
							<div>
								<div class="item" v-for="(ite,ind) in item.course" :key="ind" >
									<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
									<div class="place line_two">{{ite.course_shop_name}}</div>
									<div class="info" :style="{'background':ite.color}">
										<div class="name">{{ite.course_type_name}} </div>
										<div class="age">{{ite.course_age_name}}</div>
									</div>
									<div class="tag" v-if="ite.can_num == 0" @click.stop="addWaiting(ite.id)">waiting list</div>
									<div class="tag_list flex align-center" v-else-if="ite.is_try == 1">
										<div class="tag" @click.stop="ensureOrder(ite.course_id,1,ite.id,ite.date_id,ite.combo_num)">Trial</div>
										<div class="tag" @click.stop="ensureOrder(ite.course_id,0,ite.id,ite.date_id,ite.combo_num)">Book Now</div>
									</div>
									<div class="tag" @click.stop="ensureOrder(ite.course_id,0,ite.id,ite.date_id,ite.combo_num)" v-else>Book Now</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="leason_model" v-if="type>0">
			<leason v-if="type == 1" 
			ref="leason"
			:orderDetail="orderDetail" 
			:childList="childList" 
			:courseList="secondCourseList"
			:selectAll="selectAll"
			:hasPack="hasPack"
			:combo_num="combo_num"
			@close="close"
			@selectAllCourse="selectAllCourse"
			@selectCourse = 'selectCourse'
			></leason>
			<TryLeason
			v-else-if="type == 2"
			 ref="tryLeason"
			 :orderDetail="orderDetail"
			 :childList="childList" 
			 :courseList="secondCourseList"
			 :tryPrice="tryPrice"
			 @close="close"
			 @selectTryCourse = 'selectTryCourse'
			></TryLeason>
		</div>
		<div class="model" v-if="leasonStatus">
			<div class="model_content2">
				<div class="header">
					<div class="title">Classes</div>
					<img src="../../../assets/images/icon/close.png" alt="" @click="leasonStatus = false ">
				</div>
				<div class="list">
					<div class="item flex align-center justify-between" v-for="(item,index) in classifyDetailList" :key="index" @click="toDetail(item.shop.id)">
						<div class="left">
							<div class="name"><span class="date">{{item.type.name}}</span></div>
							<div class="address">{{item.shop.name}}</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<div class="model" v-if="showSelectChild">
			<div class="select_child_model">
				<div class="header">
					<div class="title">Select Child</div>
					<img src="../../../assets/images/icon/close.png" alt="" @click="showSelectChild = false ">
				</div>
				<div class="parent_info">
					<div class="discount_item flex align-center justify-between">
						<div class="name">Full Name:</div>
						<input type="text" class="val" v-model="full_name" placeholder="Full Name" >
					</div>
					<div class="discount_item flex align-center justify-between">
						<div class="name">Mobile:</div>
						<input type="text" class="val" v-model="contact_number" placeholder="Mobile" >
					</div>
					<div class="discount_item flex align-center justify-between">
						<div class="name">Eamil:</div>
						<input type="text" class="val" v-model="email" placeholder="Email" >
					</div>
				</div>
				<div class="price_bottom flex align-center justify-between">
					<div class="price"></div>
					<div class="btn" @click="ensureWainting">Join Waiting list</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Leason from '/src/components/parentLeason/leason.vue'
	import TryLeason from '/src/components/parentLeason/tryLeason.vue'
	export default{
		components:{
			Leason,
			TryLeason
		},
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				weekList:['Mon','Tue','Wed','Thur','Fri','Sat','Sun'],
				type:-1,
				classifyList:[],
				classifyDetailList:[],
				leasonStatus:false,
				shopList:[],
				ageList:[],
				course_age_id:'',
				course_shop_id:'',
				course_type_id:'',
				start_time:'',
				start_time1:'',
				end_time1:'',
				end_time:'',
				showTime1:'',
				showTime2:'',
				end_date:'',
				start_date:'',       
				weekStartDay:'',     //一周开始事件
				weekDayList:[],     //每周日期列表
				secondCourseList:[],     //日历课程列表
				problemList:[],
				content:'',
				contact:'',
				name:'',
				courseIntro:{},
				orderDetail:{},
				courseList:[],
				childList:[],
				selectAll:false,
				timeStatus:'',
				timeOptions:[{
					value:0,
					label:'AM'
				},{
					value:1,
					label:'PM'
				}],
				selectWeekList:[{id:0,label:'Monday'},{id:1,label:'Tuesday'},{id:2,label:'Wednesday'},{id:3,label:'Thursday'},{id:4,label:'Friday'},{id:5,label:'Saturday'},{id:6,label:'Sunday'}],
				selectWeek:'',
				select_date:'',
				hasPack:0,
				combo_num:0,
				tryPrice:'',
				leasonStatus:false,
				select_date_index:-1,
				selectChildList:[],
				showChildList:false,
				selectChild:0,
				showSelectChild:false,
				waitCourseId:'',
				full_name:'',
				contact_number:'',
				email:'',
				type_image:'',
				big_id:''
			}
		},
		created(){
			this.course_type_id = String(this.$route.query.course_type_id) ;
			this.course_shop_id = String(this.$route.query.course_shop_id) ;
			this.big_id = this.$route.query.big_course
			this.getClassify();
			this.getShopList();
			this.getAgeList();
			
			this.getChild();
			this.getpack();
			setTimeout(()=>{
				
				// var time = this.$route.query.time;
				// this.course_age_id = this.$route.query.age_id*1
				this.getWeek(new Date());
			},100)
			this.getDetail();
		},
		methods:{
			addWaiting(id){
				var token = localStorage.getItem('token');
				if(!token){
					this.$router.push('/login')
					return
				};
				this.waitCourseId = id;
				this.showSelectChild = true;
			},
			getDetail(){
				var params = {
					id:this.course_type_id
				}
				this.$api.post('Parents/getCourseTypeDetails',params,res=>{
					if(res.code == 1){
						this.type_image = res.data.curriculum_image;
					}
				})
			},
			toAdd(){
				this.$router.push('/home/userInfo/editChild')
			},
			delChild(index){
				console.log(index)
				this.selectChildList.splice(index,1);
			},
			select_child(index){
				this.showChildList = false;
				if(this.selectChildList.length>0){
					this.selectChildList = []
				}
				this.selectChildList.push(this.childList[index]);
			},
			ensureWainting(){
				
				var params = {
					course_id:this.waitCourseId,
					full_name:this.full_name,
					contact_number:this.contact_number,
					email:this.email
				}
				this.$api.post('Parents/wait',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
						this.showSelectChild = false
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			// 获取门店信息
			getShopDetail(){
				this.$api.post('Parents/getCourseByType',{course_type_id	:this.course_type_id},res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							var status = false;
							this.classifyDetailList.forEach((ite,ind)=>{
								if(ite.course_shop_id == item.course_shop_id ){
									status = true;
								}
							})
							if(!status){
								this.classifyDetailList.push(item)
							}
							
						})
						this.leasonStatus = true;
					}
				})
			},
			toDetail(id){
				this.course_shop_id = id;
				this.leasonStatus = false;
				this.getCourseList()
			},
			// 立即订课
			ensureOrder(id,type,course_id,date_id,combo_num){
				var token = localStorage.getItem('token');
				if(!token){
					this.$router.push('/login')
					return
				}
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.hasPack = res.data.combo_num;
						var params = {
							course_id:id,
							date_id:date_id,
							course_product_id:course_id
						}
						if(type == 0){
							if(this.hasPack>combo_num){
								params.combo_num = combo_num
							}else{
								params.combo_num = this.hasPack
							}
						}
						this.$api.post('parents_order/buyNowConfirmOrder',params,res=>{
							if(res.code == 1){
								if(res.data.all_list.length == 0){
									this.$message({
										showClose:true,
										duration:0,
										message:'Coming soon ! Watch this space !'
									})
									return;
								}
								if(type == 1){
									this.type = 2
								}else{
									this.selectAll = false;
									if(this.hasPack>combo_num){
										this.combo_num = combo_num;
									}else{
										this.combo_num = this.hasPack
									}
									this.type = 1;
								}
								var allStatus = true;
								res.data.all_list.forEach((item,index)=>{
									item.start_time = item.start_time.substring(0,5)
									item.end_time = item.end_time.substring(0,5)
									
									if(item.id == course_id){
										item.select = true;
										this.tryPrice = item.try_price
									}else{
										if(item.is_expired){
											if(type == 1){
												if(item.is_try == 0){
													item.is_expired = false;
												}
												
											}
											item.select = false;
											allStatus = false
										}
										
									}
								});
								this.selectAll = allStatus;
								this.secondCourseList = res.data.all_list;
								this.orderDetail = res.data;
							}else if(res.code == 66){
								this.$message({
									showClose:true,
									duration:0,
									message:res.msg
								})
								setTimeout(()=>{
									this.$router.push('/home/userInfo/editChild')
								},500)
								
							}else{
								this.$message({
									showClose:true,
									duration:0,
									message:res.msg
								})
							}
						})
					}
				},err=>{
							if(err.code == '401'){
								localStorage.removeItem('token');
								this.$router.push('/login')
							}
						})
				
			},
			// 获取套餐余量
			getpack(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.hasPack = res.data.combo_num;
					}
				})
			},
			selectTryCourse(data){
				if(this.secondCourseList[data.index].is_try == 0){
					this.$message({
						showClose:true,
						duration:0,
						message:'Auditions are not supported'
					})
					return
				}
				this.secondCourseList.forEach((item,index)=>{
					item.select = false;
				})
				this.secondCourseList[data.index].select = true;
				this.tryPrice = this.secondCourseList[data.index].try_price;
				this.$forceUpdate()
			},
			// 选择小课
			selectCourse(data){
				this.secondCourseList[data.index].select = !this.secondCourseList[data.index].select;
				var status = false;
				var courseNum = 0;
				this.selectAll = true
				this.secondCourseList.forEach((item,index)=>{
					if(item.is_expired){
						if(!item.select){
							status = true
						}else{
							courseNum += item.combo_num*1
						}
					}
					
				})
				if(status){
					this.selectAll = false
				}
				
				
				if(this.hasPack > courseNum){
					this.combo_num = courseNum
				}else{
					this.combo_num = this.hasPack
				}
				this.$forceUpdate()
				setTimeout(()=>{
					this.$refs.leason.buyCourse();
				},100)
			},
			selectAllCourse(data){
				this.selectAll = !this.selectAll;
				var courseNum = 0
				this.secondCourseList.forEach((item,index)=>{
					if(this.selectAll){
						if(item.is_expired){
							item.select = true;
							courseNum += item.combo_num*1;
						}
					}else{
						item.select = false
					}
				})
				
				
				if(this.hasPack > courseNum){
					this.combo_num = courseNum
				}else{
					this.combo_num = this.hasPack
				}
				this.$forceUpdate()
				setTimeout(()=>{
					this.$refs.leason.buyCourse();
				},100)
			},
			// 获取孩子列表
			getChild(){
				this.$api.post('user/getChildList',{},res=>{
					if(res.code == 1){
						this.childList = res.data;
					}
				})
			},
			
			// 关闭弹窗
			close(){
				this.type = -1;
			},
			changeTime(e){
				console.log(e)
				if(this.timeStatus == 0){
					this.start_time = '00:00';
					this.end_time = '12:00'
				}else{
					this.start_time = '12:00';
					this.end_time = '24:00'
				}
				this.getCourseList()
			},
			changeWeek(e){
				var start = this.start_date.substring(this.start_date.length-2)
				this.select_date_index = e
				if(this.weekDayList[e] > start){
					this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[e]
				}else{
					this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[e]
				}
				this.getCourseList()
			},
			
			getWeek(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.weekDayList = weekList;
				this.showTime1 = day1+'/'+month1+'/'+year1;
				this.showTime2 = day2+'/'+month2+'/'+year2;
				this.start_date = year1+'-'+month1+'-'+day1;
				this.end_date = year2+'-'+month2+'-'+day2;
				var start = this.start_date.substring(this.start_date.length-2);
				if(this.select_date_index>=0){
					if(this.weekDayList[this.select_date_index] > start){
						this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[this.select_date_index]
					}else{
						this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[this.select_date_index]
					}
				}
				this.getCourseList()
			},
			lastMonth(){
				var date = new Date(this.start_date).getTime();
				date = date - 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			nextMonth(){
				var date = new Date(this.end_date).getTime();
				date = date + 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			getCourseList(){
				console.log(this.selectWeek)
				var params = {
					start_date:this.start_date,
					end_date:this.end_date,
					start_time:this.start_time,
					end_time:this.end_time,
					course_age_id:this.course_age_id,
					course_type_id:this.course_type_id,
					course_shop_id:this.course_shop_id,
					date:this.select_date
				}
				this.$api.post('Parents/getCourseList',params,res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.courseList = res.data;
					}
				})
			},
			getClassify(){
				this.$api.post('Parents/getCourseType',{},res=>{
					if(res.code == 1){
						this.classifyList = res.data;
					}
				})
			},
			getShopList(){
				this.$api.post('Parents/getCourseShop',{},res=>{
					if(res.code == 1){
						this.shopList = res.data;
					}
				})
			},
			getAgeList(){
				this.$api.post('Parents/getCourseAge',{},res=>{
					if(res.code == 1){
						this.ageList = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.intro{
		width: 1200px;
		margin: 0 auto;
		padding: 50px 0 20px 0;
		text-align: center;
		img{
			width:100%;
			height:auto;
		}
		div{
			text-align: center;
		}
	}
	.canClick{
		cursor: pointer;
		text-align: center;
		font-size: 18px;
		font-weight: bold;
		padding-top: 0;
		color: #BF5F49;
	}
	.second_intro{
		font-size: 16px;
		// font-weight: bold;
		padding-top: 0;
		text-align: center;
	}
	.calendar_box{
		width: 100%;
		background: #5C707A;
		padding-bottom: 40px;
		.calendar_main{
			width: 1200px;
			margin: 0 auto;
			padding-top: 40px;
			.select_list{
				.item{
					// padding: 0 20px;
					height: 60px;
					background: #FFFFFF;
					border-radius: 10px;
					margin-right: 40px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					img{
						width: 27px;
						height: 15px;
						margin-left: 10px;
					}
				}
			}
			::v-deep .el-select-dropdown__list{
				padding: 15px 0;
			}
			::v-deep .el-select{
				// width: 100%;
				height: 100%;
			}
			::v-deep .el-input.el-input--suffix{
				height: 100%;
			}
			::v-deep .el-input__icon{
				line-height: 56px;
			}
			::v-deep .el-input--suffix .el-input__inner{
				height: 100%;
				font-size: 18px;
				background-color: #F7F2EB;
				border: none;
				color: #282E30;
			}
			::v-deep .el-time-spinner__item{
				text-align: center;
			}
			.calendar_header{
				margin-top: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				img{
					width: 25px;
					height: 26px;
				}
				.left{
					cursor: pointer;
					span{
						margin-left: 10px;
					}
				}
				.right{
					cursor: pointer;
					span{
						margin-right: 10px;
					}
				}
			}
			.weeklist{
				margin-top: 30px;
				.weekName{
					.item{
						width: 150px;
						height: 60px;
						border: 1px solid #FFFFFF;
						border-radius: 10px;
						padding-left: 30px;
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 60px;
						.day{
							margin-left: 15px;
						}
					}
				}
				.course_list{
					margin-top: 20px;
					.day_item{
						width: 150px;
						.item{
							width: 100%;
							height: 220px;
							padding-top: 5px;
							background: #FFFFFF;
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #282E30;
							line-height: 30px;
							text-align: center;
							border-radius: 10px;
							overflow: hidden;
							margin-bottom: 20px;
							cursor: pointer;
							.time{
								text-align: center;
								
							}
							.place{
								text-align: center;
								height: 60px;
							}
							.info{
								height: 80px;
								background: #C98B2C;
								line-height: 26px;
								text-align: center;
								font-size:14px;
								.name{
									text-align: center;
									height: 50px;
									line-height: 25px;
									// overflow: hidden;
									// text-overflow: ellipsis;
									// white-space: nowrap;
								}
								.age{
									font-size: 12px;
									text-align: center;
								}
								&.red{
									background: #BF5F49;
								}
							}
							.tag{
								width: 70px;
								height: 26px;
								border: 1px solid #000000;
								border-radius: 13px;
								font-size: 12px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #000000;
								text-align: center;
								line-height: 26px;
								margin: 7px auto 0;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
	.leason_model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: rgba(0,0,0,0.2);
		z-index: 99;
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content2{
			width: 750px;
			height: 600px;
			overflow-y: scroll;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 0 30px;
			.header{
				width: 100%;
				height: 88px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.title{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					line-height: 88px;
				}
				img{
					width: 29px;
					height: 28px;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			.list{
				padding: 40px 0;
				.item{
					width: 100%;
					height: 100px;
					background: #F7F2EB;
					box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
					border-radius: 10px;
					padding: 25px 20px 20px 40px;
					margin-bottom: 20px;
					
					.name{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						line-height: 30px;
						span{
							margin-right: 20px;
						}
					}
					.address{
						margin-top: 15px;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #282E30;
					}
					.age{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
					}
				}
			}
		}
		.select_child_model{
			width: 750px;
			height: 380px;
			overflow-y: scroll;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 0 30px;
			.header{
				width: 100%;
				height: 88px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.title{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					line-height: 88px;
				}
				img{
					width: 29px;
					height: 28px;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			
			.discount_item{
				width: 100%;
				height: 62px;
				border-bottom: 1px solid #5C707A;
				padding: 0 30px 0 15px;
				.name{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
				}
				.val{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #BF5F49;
					text-align: right;
				}
				.item_btn{
					width: 110px;
					height: 30px;
					background: #5C707A;
					border-radius: 29px;
					line-height: 30px;
					text-align: center;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					margin-left: 10px;
					cursor: pointer;
				}
			}
			.price_bottom{
				margin-top: 30px;
				.price{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					span{
						color: #BF5F49;
					}
				}
				.btn{
					width: 200px;
					height: 58px;
					background: #5C707A;
					border-radius: 29px;
					line-height: 58px;
					text-align: center;
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}
</style>